import React from "react";
import clsx from "clsx";

import { ReactComponent as IconAnswers } from "../../../assets/svg/enpitsu-02.svg";

import styles from "./StepProcessBar.module.scss";

export type Props = {
  totalPage: number;
  currentPage: number;
  listAnswerPages: number[];
};

const StepProcessBar = React.forwardRef<HTMLDivElement, Props>(
  ({ totalPage, currentPage, listAnswerPages }, ref) => {
    const [arrayPages, setArrayPages] = React.useState<number[]>([]);
    const [stateChangePage, setStateChangePage] = React.useState<boolean>(
      false,
    );

    React.useEffect(() => {
      const rangeMaxPage = 13;
      const rangeMinPage = 2;
      if (totalPage < rangeMinPage) return;
      if (totalPage <= rangeMaxPage && arrayPages.length === 0) {
        setArrayPages(Array.from({ length: totalPage }, (_, i) => i + 1));
      } else if (totalPage > rangeMaxPage && arrayPages.length === 0) {
        currentPage > rangeMaxPage
          ? setArrayPages(
              Array.from({ length: rangeMaxPage }, (_, i) => i + currentPage),
            )
          : setArrayPages(
              Array.from({ length: rangeMaxPage }, (_, i) => i + 1),
            );
      } else if (
        currentPage > arrayPages[arrayPages.length - 1] ||
        currentPage < arrayPages[0]
      ) {
        setArrayPages(
          Array.from({ length: rangeMaxPage }, (_, i) =>
            currentPage > rangeMaxPage &&
            currentPage > arrayPages[arrayPages.length - 1]
              ? i + currentPage - rangeMaxPage + 1
              : i + currentPage,
          ),
        );
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, totalPage]);

    React.useEffect(() => {
      setStateChangePage(true);
      const timer = setTimeout(() => {
        setStateChangePage(false);
      }, 1500);
      return () => clearTimeout(timer);
    }, [currentPage]);

    return (
      <div
        className={clsx(styles.wrapper, stateChangePage ? "" : styles.fadeOut)}
        ref={ref}
      >
        {arrayPages.map((page: number) => (
          <div
            className={clsx(
              styles.StepProgress,
              currentPage === page && styles.is_current,
            )}
            key={page}
          >
            {listAnswerPages.includes(page) && <IconAnswers />}
          </div>
        ))}
      </div>
    );
  },
);

export default StepProcessBar;
